import { read, update } from '@/api/rest';

const person = {
  profile: async () => await read('/person/profile'),
  profileUpdate: async (data) => await update('/person/profile-update', data),
  /**
   * Поиск публикаций пользователя
   * @param {URLSearchParams} params
   * @returns {Promise<*>}
   */
  profilePublications: async (params) =>
    await read(`/person/publications?${params.toString()}`),
};
export default person;
